<template lang="pug">
  include ./vuek/mixins.pug
  +b.app#app
    router-view
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
@import 'scss/styles';
@import 'scss/index';

@font-face {
  font-family: 'hfont';
  src: url('/static/fonts/pfdintextpro-bold.woff') format('woff'),
  url('/static/fonts/pfdintextpro-bold.woff2') format('woff2');
  font-weight: bold;
  font-style: bold;
}

@font-face {
  font-family: 'hfont';
  src: url('/static/fonts/pfdintextpro-light.woff') format('woff'),
  url('/static/fonts/pfdintextpro-light.woff2') format('woff2');
  font-weight: light;
  font-style: light;
}

@font-face {
  font-family: 'font';
  src: url('/static/fonts/minionpro-regular.woff') format('woff'),
  url('/static/fonts/minionpro-regular.woff2') format('woff2');
  font-weight: bold;
  font-style: bold;
}


.app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // margin-top: 60px;
  min-width: 1024px;

  &__container {
    max-width: 1200px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue